
export default class MixPanel {
    private static mixpanel: any = (<any>window).mixpanel;

    static identify(memberKey: string): void {
        this.mixpanel.identify(`[${memberKey}]`);
    }

    static setMemberInformation(email: string, created: string, company: string, jobTitle: string,
        firstName: string, lastName: string,  jobLocation: string, primaryPhone: string,
        personalEmail: string, secondaryPhone: string, causes: string[]): void {

        this.mixpanel.people.set({
            "$email": email, "$created": created, "$last_login": new Date(),
            "Company": company, "First_Name": firstName, "Last_Name": lastName, "Job_title": jobTitle,
            "Job_Location": jobLocation, "Personal_Email": personalEmail, "Primary Phone": primaryPhone,
            "Secondary Phone": secondaryPhone, "Causes": causes}
         );
    }
}



// WEBPACK FOOTER //
// ./static-content/public/javascripts/services/mixpanel.ts